'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = deepMerge;
function deepMerge() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var src = arguments[1];

  var array = Array.isArray(src);
  var dst = array && [] || {};

  if (array) {
    dst = dst.concat(target);
    src.forEach(function (e, i) {
      if (typeof dst[i] === 'undefined') {
        dst[i] = e;
      } else if ((typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object') {
        dst[i] = deepMerge(target[i], e);
      } else if (target.indexOf(e) === -1) {
        dst.push(e);
      }
    });
  } else {
    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object') {
      Object.keys(target).forEach(function (key) {
        dst[key] = target[key];
      });
    }
    Object.keys(src).forEach(function (key) {
      if (_typeof(src[key]) !== 'object' || !src[key]) {
        dst[key] = src[key];
      } else if (!target[key]) {
        dst[key] = src[key];
      } else {
        dst[key] = deepMerge(target[key], src[key]);
      }
    });
  }

  return dst;
}


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels/utilities/deepMerge.js
// module id = 1130
// module chunks = 4